import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { AppUtilities } from 'src/app/app.utility';
import { FileDownloadService, PdfFilesType } from 'src/app/services/file-download.service';
import { AppInsightsService } from '../../services/appinsights.service';

@Component({
  selector: 'app-negotiations',
  templateUrl: './negotiations.component.html',
  styleUrls: ['./negotiations.component.scss']
})
export class NegotiationsComponent implements AfterViewInit, OnDestroy {

    @ViewChild('negotiationsVideo') negotiationsVideoRef: ElementRef;

    private videoEventLogged = false;
    private onWindowBlur = () => {
        if (!this.videoEventLogged && document.activeElement === this.negotiationsVideoRef?.nativeElement) {
            this.appInsights.logCustomEvent('Video watched', 'Negotiations', null);
            this.videoEventLogged = true;
        }
    };

    constructor(private fileDownloadService: FileDownloadService, private appInsights: AppInsightsService) { }

    ngAfterViewInit(): void {
        window.addEventListener('blur', this.onWindowBlur);
    }

    ngOnDestroy(): void {
        window.removeEventListener('blur', this.onWindowBlur);
    }

    downloadNotificationsGuide(): void {
        this.fileDownloadService.download(PdfFilesType.NegotiationsGuide).subscribe(data =>
             {
                const content = new Blob([data], { type: 'application/pdf' });
                const filename = 'MinsterLawOffersGuide.pdf';
                AppUtilities.saveToFile(content, filename);
             }
        )
    }
}
